// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"6951fecb","603":"379f7ccc","609":"f5216ae7","967":"c1deb201"}[chunkId] + ".chunk.js";
};